module.exports = __webpack_public_path__ + "assets/img/njbm.0c183ad4.png";